<template>
  <div>
    <!--<div>
        <CRow>
          <CCol sm="12" v-for="concurso in listaConcursos" :key="concurso.id">
            <CCard>
              <CCardHeader>
                <CCardTitle
                  style="
                    display: inline-block;
                    margin-top: 13px;
                    margin-bottom: 0px;
                  "
                  ><b>{{ concurso.nombre }}</b></CCardTitle
                >

                <CButton
                  style="
                    float: right;
                    display: inline-block;
                    margin-top: 8px;
                    margin-bottom: 8px;
                  "
                  color="info"
                  disabled
                  >Ver detalles</CButton
                >
              </CCardHeader>
              <CCardBody>
                <CCard>
                  <CCardHeader>
                    <CRow
                      ><CCol
                        ><b>Número de expediente:</b>
                        {{ concurso.numeroExpediente }}</CCol
                      ></CRow
                    >
                  </CCardHeader>
                </CCard>

                <CCard>
                  <CCardHeader>
                    <b>Descripción:</b>
                  </CCardHeader>
                  <CCardBody>
                    <CRow
                      ><CCol>{{ concurso.descripcion }}</CCol></CRow
                    ></CCardBody
                  >
                </CCard>
                <CRow
                  ><CCol sm="6"
                    ><CCard
                      ><CCardHeader
                        ><b
                          style="
                            display: inline-block;
                            margin-top: 6px;
                            margin-bottom: 0px;
                          "
                          >Cálculo de bajas</b
                        >
                        <CButton
                          style="float: right; display: inline-block"
                          color="success"
                          disabled
                          >Calcular bajas</CButton
                        > </CCardHeader
                      ><CCardBody
                        ><CBadge color="danger">Sin calcular</CBadge></CCardBody
                      ></CCard
                    ></CCol
                  ><CCol sm="6"
                    ><CCard
                      ><CCardHeader
                        ><b
                          style="
                            display: inline-block;
                            margin-top: 6px;
                            margin-bottom: 0px;
                          "
                          >Estado del concurso</b
                        >
                        <CButton
                          style="float: right; display: inline-block"
                          color="success"
                          disabled
                          >Resolver concurso</CButton
                        ></CCardHeader
                      ><CCardBody
                        ><CBadge color="danger">Sin resolver</CBadge></CCardBody
                      ></CCard
                    ></CCol
                  ></CRow
                >
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div>-->

    <CCard>
      <CCardHeader class="d-flex justify-content-between align-items-center"
        ><h3 style="margin-top: 8px; display: inline-block">
          Lista de concursos
        </h3>
        <CustomExport
          :lista="listaConcursosFiltrados"
          :fields="camposTabla"
          :name="'Lista de concursos'"
        ></CustomExport
      ></CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
              hover
              striped
              :tableFilter="{ placeholder: 'Introducir valor', label: 'Buscar', external: true, lazy: true }"
              :table-filter-value.sync="tableFilterVal"
              :itemsPerPageSelect="{
                label: 'Elementos por página',
                values: [5, 10, 15, 20, 25],
              }"
              :items-per-page="5"
              :items="listaConcursosFiltrados"
              :fields="camposTabla"
              sorter
              pagination
            >
              <template #acciones="{ item }">
                <td style="float: right">
                  <CButton v-if="item.estadoConcurso != 'Cerrado'"
                    color="secondary"
                    @click="openDetails(item.idConcurso)"
                    style="display: inline-block; margin-right: 10px"
                    >Ver detalles</CButton
                  >
                  <CButton v-if="item.estadoConcurso != 'Cerrado'"
                    color="info"
                    style="display: inline-block"
                    @click="editarConcurso(item)"
                    >Editar</CButton
                  >
                </td>
              </template>
              <template #ultimoCalculoBaja="{ item }">
                <td>
                  <CBadge :color="getBadge(item.ultimoCalculoBaja)">
                    {{ item.ultimoCalculoBaja }}
                  </CBadge>
                </td>
              </template>
              <template #ultimoCalculoPuntos="{ item }">
                <td>
                  <CBadge :color="getBadge(item.ultimoCalculoPuntos)">
                    {{ item.ultimoCalculoPuntos }}
                  </CBadge>
                </td>
              </template>
              <template #estadoConcurso="{ item }">
                <td>
                  <CBadge :color="getBadgeResolucion(item.estadoConcurso)">
                    {{ item.estadoConcurso }}
                  </CBadge>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal title="Información" :show.sync="showEvento" size="sm" centered>
      {{ getMessage() }}

      <template #footer>
        <CButton
          v-if="evento == 'created' || evento == 'deleted'"
          @click="showEvento = false"
          color="success"
          >Aceptar</CButton
        >
        <CButton
          v-if="evento == 'errordeleted'"
          @click="showEvento = false"
          color="danger"
          >Aceptar</CButton
        >
        <CButton
          v-if="evento == 'delete'"
          @click="aceptarEliminar"
          color="danger"
          >Eliminar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<style scoped>
</style>

<script>
import Cookies from "js-cookie";
import CustomExport from "../../utils/CustomExport";
import { getAllConcursos } from "../../requests/concursos";
import { logOut } from "../../utils/authUtils";

export default {
  name: "ConsultarConcursos",
  components: {
    CustomExport,
  },
  created() {},
  mounted() {
    //despues de crear un concurso muestra un popup con la confirmacion, el evento se recibe a traves de la url
    this.evento = this.$route.query.event;
    this.$router.replace({ query: null }); //limpia la url
    if (this.evento) this.showEvento = true;

    this.cargarConcursos();
  },
  data() {
    return {
      evento: undefined, //cuando se redirige a esta pagina y se envia un evento en el path de la url
      showEvento: false, //se muestra el modal con la información, normalmente despues de haberse creado un concurso
      concursoSeleccionado: {}, //concurso seleccionado para eliminar concurso DE MOMENTO NADA
      tableFilterVal: "",
      listaConcursos: [],
      listaConcursosFiltrados: [],
      camposTabla: [
        { key: "nombre", field: "Nombre", label: "Nombre" },
        {
          key: "numeroExpediente",
          field: "Número de expediente",
          label: "Número de expediente",
        },
        {
          key: "ultimoCalculoBaja",
          field: "Cálculo de baja",
          label: "Cálculo de baja",
        },
        {
          key: "ultimoCalculoPuntos",
          field: "Cálculo de puntos",
          label: "Cálculo de puntos",
        },
        {
          key: "estadoConcurso",
          field: "Estado del concurso",
          label: "Estado del concurso",
        },
        { key: "acciones", label: "" },
      ],
      camposExportar: [
        "Nombre",
        "Número de expediente",
        "Cálculo de baja",
        "Estado del concurso",
      ],
    };
  },
  computed: {
    tableState() {
      return [
        this.tableFilterVal,
      ];
    }
  },
  watch: {
    tableState() {
      this.listaConcursosFiltrados = this.listaConcursos
      this.setTableFilterValue();
    }
  },
  methods: {
    setTableFilterValue() {
      //console.log(this.tableFilterVal);

      this.listaConcursosFiltrados = this.listaConcursos.filter(concurso => {
       
        if (Object.values(concurso).some(valor => {
          valor = String(valor).toLowerCase()
          const filtroTabla = String(this.tableFilterVal).toLowerCase()
          return valor.search(filtroTabla) > -1
          } ) ){
            return concurso
          }
      });
      // console.log("listaConcursosFiltrados", this.listaConcursosFiltrados);
    },
    //pendientes de ser modificados para ver que colores se eligen, son el color de los cartelitos de estado
    getBadge(idEstado) {
      switch (idEstado) {
        case "Pendiente":
          return "warning";
        case "Calculado":
          return "success";
      }
    },
    getBadgeResolucion(idEstado) {
      //console.log(idEstado);
      switch (idEstado) {
        case "Cerrado":
          return "danger";
        case "Pendiente":
          return "warning";
        case "Abierto":
          return "info";
        case "En Resolución":
          return "success";
      }
    },
    editarConcurso(concurso){
     // console.log(concurso)
      this.$router.push({ path: "/concursos/editar?idConcurso="+concurso.idConcurso})
    },
    //carga todos los concursos y modifica algun campo
    cargarConcursos() {
      getAllConcursos()
        .then((res) => {
          this.listaConcursos = [];
          res.data.forEach((element) => {
            this.listaConcursos.push({
              nombre: element.nombre,
              idConcurso: element.id,
              numeroExpediente: element.numeroExpediente,
              ultimoCalculoBaja: element.ultimoCalculoBaja
                ? "Calculado"
                : "Pendiente",
              ultimoCalculoPuntos: element.ultimoCalculoPuntos
                ? "Calculado"
                : "Pendiente",
              estadoConcurso: element.estadoConcurso,
            });
          });
          this.listaConcursosFiltrados = this.listaConcursos
        })
        .catch((error) => {
          if (error.response.status == 403 || error.response.status == 401)
            logOut(this.$router);
        });
    },
    openDetails(idConcurso) {
      this.$router.push({ path: "/concursos/detalle?id=" + idConcurso }); //redirige a los detalles del concurso
    },
    getMessage() {
      //en funcion del evento mostrará un mensaje u otro
      if (this.evento) {
        switch (this.evento) {
          case "created": //cuando redirija despues de crear un concurso correctamente
            return "Concurso creado correctamente";
        }
      }
    },
  },
  beforeDestroy() {},
};
</script>
